export default {
    and_more_dates_plural: "Et {dates} autres dates",
    and_more_dates: "Et {dates} autre date",
    attend_this_face_to_face_class_at_the_address_indicated: "Assistez à ce cours en présentiel à l'adresse indiquée",
    awaiting_results: "En attente de résultats",
    canceled: "Annulé",
    check_your_availability_at_all_times_before_confirming_your_presence: "Vérifiez vos disponibilités à tout moment avant de confirmer votre présence.",
    class_date: "Date de cours",
    closed: "Invité uniquement",
    do_you_confirm_your_registration_for_the_presential_class: "Confirmez-vous votre inscription le cours en présentiel {title}?",
    do_you_confirm_your_unsubscription_to_the_presential_class: "Confirmez-vous votre désinscription le cours en présentiel {title}?",
    end_time: "Heure de fin",
    event_type: "Type d'événement",
    finished: "Fini",
    in_progress: "En cours",
    intermission: "Intervalle",
    live: "Vivre",
    loading_presential_classes: "Chargement les cours en présentiel",
    model: "Modèle",
    next: "Prochain",
    no_presential_classes_are_available_at_the_moment: "Il n'y a actuellement aucun cours en présentiel disponible",
    no_presential_classes_are_available_with_the_selected_filter: "Aucun cours en présentiel n'est disponible pour le filtre sélectionné",
    opened: "Ouvert",
    please_wait_for_instructor_presence_check: "Veuillez attendre la validation de l'instructeur",
    pre_scheduled: "Pré-programmé",
    presential_class_offline: "Cours en présentiel hors ligne",
    presential_event: "Présentiel réussie",
    receive_emails_about_this_presential_class: "Recevez des e-mails concernant ce cours en présentiel",
    register_for_the_presential_class: "Inscrivez-vous le cours en présentiel",
    reproved: "Désapprouvé",
    scheduled: "Programmé",
    start_time: "Heure de début",
    subscribe: "S'inscrire",
    subscribed: "Inscrit",
    successfully_signed_up_for_the_presential_class: "Inscription le cours en présentiel réussie",
    this_class_has_already_ended_finish_the_rest_of_the_days_activities: "Ce cours est déjà terminé. Terminez le reste des activités de la journée",
    this_class_has_already_ended: "Ce cours est déjà terminé.",
    transmission_date: "Date de transmission",
    transmission_finished: "Transmission terminée",
    unsubscribe_from_the_presential_class: "Se désinscrire du cours en présentiel",
    unsubscribe_successfully_for_the_presential_class: "Se désinscrire avec succès pour le cours en présentiel",
    unsubscribe: "Se désabonner",
    you_already_have_a_certificate_for_this_type_of_event: "Vous avez déjà une attestation pour ce type d'événement",
    your_presential_class_will_start_soon_please_wait: "Votre cours en présentiel va bientôt commencer, veuillez patienter"
}